import { useModules } from '@/hooks/use-settings';

export function usePlatformModules() {
  const { data, isLoading, error } = useModules();

  const enabledModules: string[] = data?.modules
    ? Object.entries(data.modules)
        .filter(([, enabled]) => enabled)
        .map(([key]) => key)
    : [];

  const isModuleEnabled = (key: string): boolean => {
    if (!data?.modules) return false;
    return data.modules[key as keyof typeof data.modules] ?? false;
  };

  return {
    enabledModules,
    isModuleEnabled,
    isLoading,
    error,
    modules: data?.modules ?? null,
  };
}
